/* Tropik Hasat v2 */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(c) {
    var lira = Math.floor(c / 100), kurus = c % 100;
    var s = String(lira).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (kurus) s += ',' + (kurus < 10 ? '0' : '') + kurus;
    return s + ' ₺';
  }

  /* Paneller (menü, arama, sepet) */
  function panel(name) { return $('[data-panel="' + name + '"]'); }
  function openPanel(name) {
    var p = panel(name); if (!p) return;
    p.hidden = false; document.body.style.overflow = name === 'search' ? '' : 'hidden';
    if (name === 'search') { var i = $('input[type=search]', p); if (i) i.focus(); }
  }
  function closePanels() {
    $$('[data-panel]').forEach(function (p) { p.hidden = true; });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      e.preventDefault();
      var name = o.getAttribute('data-open');
      var p = panel(name);
      if (name === 'search' && p && !p.hidden) { closePanels(); return; }
      closePanels(); openPanel(name); return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closePanels(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* Sepet */
  function refreshCart() {
    return fetch(window.theme.cartUrl + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-cart-ship]', '[data-cart-lines]', '[data-cart-foot]'].forEach(function (sel) {
        var next = $(sel, doc), cur = $('.cd ' + sel);
        if (next && cur) cur.innerHTML = next.innerHTML;
        else if (next && !cur && sel === '[data-cart-foot]') { $('.cd__box').appendChild(next); }
        else if (!next && cur && sel === '[data-cart-foot]') { cur.remove(); }
      });
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.classList.toggle('is-zero', !cart.item_count); });
      $$('[data-cart-count-inline]').forEach(function (n) { n.textContent = '(' + cart.item_count + ')'; });
      return cart;
    });
  }

  function addToCart(form, btn) {
    var label = btn && $('span', btn);
    var orig = label ? label.textContent : '';
    if (btn) { btn.classList.add('is-loading'); }
    var fd = new FormData(form);
    fd.delete('option-1'); fd.delete('option-2'); fd.delete('option-3');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Sepete eklenemedi'); return j; }); })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-ok'); if (label) label.textContent = 'Eklendi ✓'; setTimeout(function () { btn.classList.remove('is-ok'); if (label) label.textContent = orig; }, 1400); }
        closePanels(); openPanel('cart');
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); if (label) label.textContent = orig; }
        window.alert(err.message || 'Bir sorun oluştu, lütfen tekrar deneyin.');
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-quick-add]')) { e.preventDefault(); addToCart(f, $('[data-add]', f)); }
    if (f.matches('[data-product-form]')) { e.preventDefault(); addToCart(f, $('[data-atc]', f)); }
  });

  function changeLine(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: qty }) })
      .then(function () { if ($('[data-cart-page]')) { location.reload(); return; } return refreshCart(); });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove'), 0); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var box = step.closest('[data-qty],[data-qty-box]'), input = $('[data-qty-input]', box);
      var val = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-qty-step')));
      if (input.closest('[data-product-form]')) { input.value = Math.max(1, val); return; }
      input.value = val; changeLine(input.getAttribute('data-line'), val);
    }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-qty-input]');
    if (i && i.getAttribute('data-line')) changeLine(i.getAttribute('data-line'), Math.max(0, parseInt(i.value, 10) || 0));
    var sel = e.target.closest('[data-variant-select]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex], card = sel.closest('.pc');
      var pr = $('[data-price]', card); if (pr) pr.textContent = money(Number(opt.getAttribute('data-price')));
      var cn = $('[data-count]', card), cv = opt.getAttribute('data-count');
      if (cn) { cn.textContent = cv ? '≈ ' + cv : ''; cn.hidden = !cv; }
      var from = $('.from', card); if (from) from.remove();
    }
  });

  /* Ürün sayfası */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var variants = JSON.parse($('[data-product-json]', pdp).textContent);
    var form = $('[data-product-form]', pdp);
    var idInput = $('[data-variant-id]', form);
    var fieldsets = $$('.opt', form);

    function unitText(v) {
      var t = String(v.title || '').toLowerCase().replace(',', '.').trim(), a = 0, m;
      if ((m = t.match(/^([\d.]+)\s*kg/))) a = parseFloat(m[1]);
      else if ((m = t.match(/^([\d.]+)\s*gr/))) a = parseFloat(m[1]) / 1000;
      return a > 0 && a !== 1 ? 'kg başı ' + money(Math.round(v.price / a)) : '';
    }
    function pieces(title) {
      var pc = form.getAttribute('data-adet'); if (!pc) return '';
      var t = String(title || '').toLowerCase().replace(',', '.').trim(), kg = 0, m;
      if ((m = t.match(/^([\d.]+)\s*kg/))) kg = parseFloat(m[1]); else if ((m = t.match(/^([\d.]+)\s*gr/))) kg = parseFloat(m[1]) / 1000;
      if (!kg) return '';
      var parts = pc.split('-').map(function (x) { return parseFloat(x); }), lo = Math.round(parts[0] * kg);
      var hi = parts.length > 1 ? Math.round(parts[1] * kg) : lo;
      return (hi !== lo ? lo + '-' + hi : lo) + ' adet';
    }
    function selectedOptions() {
      return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v['option' + (i + 1)] === o; });
      })[0];
    }
    function render(v) {
      if (!v) {
        $('[data-atc]', form).disabled = true; $('[data-atc-label]', form).textContent = 'Bu seçenek yok';
        return;
      }
      idInput.value = v.id;
      $('[data-now]', pdp).textContent = money(v.price);
      var was = $('[data-was]', pdp), badge = $('[data-badge]', pdp);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        was.hidden = false; was.textContent = money(v.compare_at_price);
        badge.hidden = false; badge.textContent = '%' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' indirim';
      } else { was.hidden = true; badge.hidden = true; }
      $('[data-unit]', pdp).textContent = unitText(v);
      var cEl = $('[data-count]', pdp), pcv = pieces(v.title);
      if (cEl) { cEl.textContent = pcv ? '≈ ' + pcv : ''; cEl.hidden = !pcv; }
      $('[data-stock]', pdp).innerHTML = v.available ? '<span class="dot dot--ok"></span>Stokta' : '<span class="dot dot--no"></span>Tükendi';
      var atc = $('[data-atc]', form), st = $('[data-sticky-atc]');
      var bn = $('[data-buy-now]', form); if (bn) bn.hidden = !v.available;
      atc.disabled = !v.available; $('[data-atc-label]', form).textContent = v.available ? 'Sepete ekle' : 'Tükendi';
      if (st) { st.disabled = !v.available; st.textContent = v.available ? 'Sepete ekle' : 'Tükendi'; }
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var wl = $('[data-wa-label]'); if (wl) wl.textContent = v.available ? "WhatsApp'tan sorun / sipariş verin" : 'Stok gelince haber verin (WhatsApp)';
      fieldsets.forEach(function (fs, i) { var o = $('[data-opt-val]', fs); if (o) o.textContent = v['option' + (i + 1)]; });
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    function markUnavailable() {
      fieldsets.forEach(function (fs, i) {
        var opts = selectedOptions();
        $$('.pill', fs).forEach(function (p) {
          var val = $('input', p).value, test = opts.slice(); test[i] = val;
          var v = findVariant(test);
          p.classList.toggle('is-off', !v || !v.available);
        });
      });
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches('.opt input')) return;
      var opts = selectedOptions(), v = findVariant(opts);
      if (!v) { /* seçim kombinasyonu yoksa ilk seçeneği koruyup en yakın varyanta düş */
        var i = fieldsets.indexOf(e.target.closest('.opt'));
        v = variants.filter(function (x) { return x['option' + (i + 1)] === e.target.value; })[0];
        if (v) fieldsets.forEach(function (fs, k) { $$('input', fs).forEach(function (inp) { inp.checked = inp.value === v['option' + (k + 1)]; }); });
      }
      render(v); markUnavailable();
    });
    markUnavailable();

    /* Uzun ürün bilgisini kısalt, ok ile aç */
    var desc = $('[data-desc]', pdp), descBtn = $('[data-desc-toggle]', pdp);
    if (desc && descBtn) {
      var clean = function () {
        var props = ['margin', 'marginTop', 'marginBottom', 'padding', 'paddingTop', 'paddingBottom', 'lineHeight', 'height', 'minHeight'];
        $$('*', desc).forEach(function (e) {
          props.forEach(function (p) { if (e.style) e.style[p] = ''; });
          if (!/^(IMG|BR|HR|LI|UL|OL|TD|TR|TABLE|TBODY)$/.test(e.tagName) && !e.querySelector('img') && !e.textContent.replace(/\u00a0/g, ' ').trim()) e.remove();
        });
      };
      clean();
      var limit = 10.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      var setup = function () {
        if (desc.scrollHeight > limit + 40) { desc.classList.add('is-clamped'); descBtn.hidden = false; }
      };
      setup(); window.addEventListener('load', setup);
      descBtn.addEventListener('click', function () {
        var open = descBtn.getAttribute('aria-expanded') === 'true';
        descBtn.setAttribute('aria-expanded', String(!open));
        desc.classList.toggle('is-clamped', open);
        $('span', descBtn).textContent = open ? 'Devamını oku' : 'Daha az göster';
      });
    }

    /* Hemen satın al + Birlikte satın alın */
    function mainVariant() { return variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0]; }
    function mainQty() { return Math.max(1, parseInt($('[data-qty-input]', form).value, 10) || 1); }
    var bundle = $('[data-bundle]', pdp);
    function bundleItems() {
      return $$('[data-bundle-item]', bundle).filter(function (li) { return $('[data-bundle-check]', li).checked; }).map(function (li) {
        var s = $('[data-bundle-var]', li), o = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s;
        return { id: Number(s.value), price: Number(o.getAttribute('data-price')) };
      });
    }
    function updateBundle() {
      if (!bundle) return;
      var mv = mainVariant(), total = mv ? mv.price * mainQty() : 0;
      var m = $('[data-bundle-main]', bundle); if (m && mv) m.textContent = money(mv.price);
      $$('[data-bundle-item]', bundle).forEach(function (li) {
        var s = $('[data-bundle-var]', li), o = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s;
        var pr = Number(o.getAttribute('data-price')); $('[data-bundle-price]', li).textContent = money(pr);
        var on = $('[data-bundle-check]', li).checked; li.classList.toggle('is-off', !on); if (on) total += pr;
      });
      $('[data-bundle-total]', bundle).textContent = money(total);
      var btn = $('[data-bundle-add]', bundle); if (mv) btn.disabled = !mv.available;
    }
    if (bundle) {
      bundle.addEventListener('change', updateBundle);
      form.addEventListener('change', function () { setTimeout(updateBundle, 0); });
      document.addEventListener('click', function (e) { if (e.target.closest('[data-qty-step]')) setTimeout(updateBundle, 0); });
      updateBundle();
      $('[data-bundle-add]', bundle).addEventListener('click', function (e) {
        var btn = e.currentTarget, lab = $('span', btn), orig = lab.textContent; btn.classList.add('is-loading');
        var items = [{ id: Number(idInput.value), quantity: mainQty() }].concat(bundleItems().map(function (i) { return { id: i.id, quantity: 1 }; }));
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Sepete eklenemedi'); return j; }); })
          .then(function () { return refreshCart(); })
          .then(function () { btn.classList.remove('is-loading'); lab.textContent = 'Eklendi ✓'; setTimeout(function () { lab.textContent = orig; }, 1400); closePanels(); openPanel('cart'); })
          .catch(function (err) { btn.classList.remove('is-loading'); window.alert(err.message || 'Bir sorun oluştu, lütfen tekrar deneyin.'); });
      });
    }
    var buyNow = $('[data-buy-now]', form);
    if (buyNow) buyNow.addEventListener('click', function () {
      buyNow.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: mainQty() }] }) })
        .then(function (r) { if (!r.ok) throw new Error('Sepete eklenemedi'); window.location.href = '/checkout'; })
        .catch(function (err) { buyNow.classList.remove('is-loading'); window.alert(err.message); });
    });

    /* Galeri noktaları + küçük resim */
    var track = $('[data-gal-track]', pdp);
    if (track) {
      var dots = $$('[data-gal-dots] button', pdp), thumbs = $$('[data-thumb]', pdp);
      function setOn(i) {
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }
      track.addEventListener('scroll', function () { setOn(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setOn(i); }); });
    }

    /* Yapışkan satın alma çubuğu (yalnız mobil) */
    var sticky = $('[data-sticky]'), mainAtc = $('[data-atc]', form);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || window.innerWidth >= 990; }, { threshold: 0 }).observe(mainAtc);
      $('[data-sticky-atc]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : addToCart(form, $('[data-atc]', form)); });
    }

    /* Tahmini kargo günü */
    var est = $('[data-ship-est]');
    if (est) {
      var days = est.getAttribute('data-days').split(',').map(Number).filter(Boolean), cutoff = Number(est.getAttribute('data-cutoff'));
      var names = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));
      for (var add = 0; add < 8; add++) {
        var d = new Date(now.getTime() + add * 864e5), dow = d.getDay() === 0 ? 7 : d.getDay();
        if (days.indexOf(dow) === -1) continue;
        if (add === 0 && now.getHours() >= cutoff) continue;
        est.innerHTML = add === 0 ? '<strong>Bugün</strong> sipariş verirseniz bugün kargoya çıkar' : 'Bugün sipariş verirseniz <strong>' + (add === 1 ? 'yarın' : names[d.getDay()]) + '</strong> kargoya çıkar';
        break;
      }
    }
  }

  /* Instagram videoları (resmi embed, dokununca açılır) */
  var rbox = $('[data-reelbox]');
  if (rbox) {
    var slot = $('[data-reel-slot]', rbox);
    document.addEventListener('click', function (e) {
      var r = e.target.closest('[data-reel]');
      if (r) {
        var f = document.createElement('iframe');
        f.src = 'https://www.instagram.com/reel/' + encodeURIComponent(r.getAttribute('data-reel')) + '/embed/';
        f.setAttribute('allowfullscreen', ''); f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen'); f.setAttribute('title', 'Instagram videosu');
        slot.textContent = ''; slot.appendChild(f); rbox.hidden = false; document.body.style.overflow = 'hidden'; return;
      }
      if (e.target.closest('[data-reel-close]')) { rbox.hidden = true; slot.textContent = ''; document.body.style.overflow = ''; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !rbox.hidden) { rbox.hidden = true; slot.textContent = ''; document.body.style.overflow = ''; } });
  }

  /* Üretim fotoğrafı büyütme */
  var zbox = $('[data-zoombox]');
  if (zbox) {
    var zimg = $('[data-zoom-img]', zbox);
    var zclose = function () { zbox.hidden = true; zimg.removeAttribute('src'); document.body.style.overflow = ''; };
    document.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom]');
      if (z) { zimg.src = z.getAttribute('data-zoom'); zimg.alt = z.getAttribute('data-zoom-alt') || ''; zbox.hidden = false; document.body.style.overflow = 'hidden'; return; }
      if (e.target.closest('[data-zoom-close]')) zclose();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zbox.hidden) zclose(); });
  }

  /* Yana kaydırma okları */
  $$('[data-scroller]').forEach(function (sc) {
    var track = $('[data-scroll-track]', sc), prev = $('[data-scroll="-1"]', sc), next = $('[data-scroll="1"]', sc);
    if (!track) return;
    function upd() {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: Number(b.getAttribute('data-scroll')) * track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
    var cnt = $('[data-scroll-count]', sc), total = track.children.length;
    function updCount() { if (cnt) cnt.textContent = (Math.min(total, Math.round(track.scrollLeft / track.clientWidth) + 1)) + ' / ' + total; }
    track.addEventListener('scroll', function () { upd(); updCount(); }, { passive: true });
    track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });

  /* Önerilen ürünler */
  $$('[data-recs]').forEach(function (el) {
    fetch(el.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html'), n = $('[data-recs]', doc);
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    }).catch(function () {});
  });
})();
